import { Theme } from "@material-ui/core";
import type { RowBoundary } from "../types/warehouse.types";
import { drawPolygon, Point } from "./canvasDrawing";

/**
 * Highlights a selected row on the canvas with a dashed line.
 * @param ctx The 2D rendering context of the canvas.
 * @param selectedRowIndex The index of the selected row.
 * @param rowBoundaries An array of all row boundaries.
 * @param worldToScreen Function to convert world coordinates to screen coordinates.
 * @param theme The Material-UI theme for color consistency.
 */
export const highlightSelectedRow = (
  ctx: CanvasRenderingContext2D,
  selectedRowIndex: number | null,
  rowBoundaries: RowBoundary[],
  worldToScreen: (x: number, y: number) => Point,
  theme: Theme
) => {
  if (selectedRowIndex === null || selectedRowIndex < 0 || selectedRowIndex >= rowBoundaries.length) {
    return;
  }

  const selectedRow = rowBoundaries[selectedRowIndex];
  const screenPolygon = selectedRow.polygon.map(p => worldToScreen(p.x, p.y));

  ctx.setLineDash([10, 5]);
  drawPolygon(ctx, screenPolygon, {
    stroke: true,
    closePath: true,
    style: {
      strokeStyle: theme.palette.warning.main,
      lineWidth: 4,
    },
  });
  ctx.setLineDash([]);
};
